<template>
  <div id="new_account" @click="closeMenu()">
    <dd-header
      :headerType=2
    />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
          />
          <div class="title">
            <h2>アカウント情報入力</h2>
            <label>下記フォームより入力してください。</label>
          </div>
          <dd-account-input
            ref="accountInput"
            :isEdit="true"
            :accountForm="accountForm"
            :isManager="true"
          />
          <div class="control_btn_area">
            <div class="main_btn sel_sub_btn" @click="cancel()">
              <a>戻る</a>
            </div>
            <div class="main_btn sel_main_btn" @click="update()">
              <a>更新する</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

// Module
import Header from '../components/common/DcHeader'
import AccountInput from '../components/user/DcAccountInput'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  name: 'UpdateAccountInput',
  components: {
    'dd-header': Header,
    'dd-account-input': AccountInput,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap,
    'dd-loading-modal': LoadingModal
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      pageKey: 'accountInput',
      pageList: [
        {id: 'accountInput', key: 'accountInput', title: 'アカウント情報入力', route: 'UpdateAccountInput'},
        {id: 'accountConfirm', key: 'accountConfirm', title: 'メールアドレス更新確認'},
        {id: 'accountComplete', key: 'accountComplete', title: 'メールアドレス更新完了'}
      ],
      accountForm: {
        email: ''
      },
      errors: {
        email: ''
      }
    }
  },
  computed: {
  },
  methods: {
    cancel: function () {
      this.$router.go(-1)
    },
    update: function () {
      this.$refs.loadingModalRef.showModal(true)
      let ret = this.$refs.accountInput.confirm()
      if (!ret) {
        this.$refs.loadingModalRef.showModal(false)
        return
      }

      this.errors = {}

      // DBに登録する
      let payload = {
        mailAddress: this.accountForm.email
      }
      axios.post(DC_URL.USER + '/update-account-check', payload
      ).then(response => {
        if (response.data.errorMessage) {
          this.errors['email'] = response.data.errorMessage
          this.$refs.accountInput.setErrorMessage(this.errors)
        } else {
          App.setLocalStorage(DC_STORAGE_KEY.UPDATE_USER, true)

          this.$router.push({
            name: 'UpdateAccountConfirm'
          })
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    fetchData: function () {
      this.accountForm = App.getLocalStorage(DC_STORAGE_KEY.ACCOUNT_DATA)
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcUpdateAccountInput.vue